import { render } from "./App.vue?vue&type=template&id=59eb5628"
const script = {}

import "./App.vue?vue&type=style&index=0&id=59eb5628&lang=scss"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/moovit-panel-licenser/licensing-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__